import { validateNamespace } from '../validateNamespace/validateNamespace';

export interface IActionTypeFactory {
    (...actionPath: string[]): string;
}

export function createActionTypeFactory (namespace: string): IActionTypeFactory {
    validateNamespace(namespace);

    return (...actionPath: string[]): string => {
        const actionType: string = actionPath.join('/');

        if (actionType.length === 0) {
            throw new Error('Redux action type must include an action path.');
        }

        if (actionType.toLowerCase() !== actionType) {
            throw new Error(`Redux action type "${namespace}/${actionType}" must be all lowercase.`);
        }

        return `${namespace}/${actionType}`;
    };
}